import { tw } from '@twind/core';
import didomiLogo from '../assets/didomi.svg';

export function DidomiLogo() {
  return (
    <div className={tw('flex h-20 w-20 items-center justify-center')} style={{ backgroundColor: '#2E62D6' }}>
      <img src={didomiLogo} alt="Didomi" className={tw('h-auto w-auto')} width={54} height={10} decoding="async" />
    </div>
  );
}
